<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font">Disclaimer</h1>
    </div>
</div>

<section class="py-5 bg-gray-100 aarni-font text-justify">
    <div class="container mx-auto px-4">
        <div class="flex justify-center">
            <div class="w-full max-w-7xl text-gray-700">
                <div class="bg-white shadow-lg rounded-lg p-6">
                    <h5 class="text-lg font-semibold">Welcome to ARNI University, Bringing Ambitions to Life.</h5>

                    <p class="mt-2">
                        Welcome to the official site of ARNI University, available at the link -
                        <a href="https://arni.in/" class="text-blue-400 font-medium">https://arni.in</a>.
                    </p>
                    <p class="mt-2">ARNI University’s website is created to provide general information about the
                        university, its
                        working culture, programs and courses, policies, and services. However, we are trying to provide
                        accurate information and timeliness with the best of our knowledge, ARNI University does not
                        claim or guarantee the completeness, suitability, or reliability of the information provided in
                        the form of any content text/image/video.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">General Information</h5>
                    <p class="mt-2">
                        The content available on the website, in the form of text or media, is for informational
                        purposes only and is subject to change without prior notice or information. ARNI reserves the
                        right to change, update, or edit content available on the website. Moreover, the information and
                        services provided may contain bugs, errors, or limitations. The company and its affiliated
                        parties are not liable for any indirect, special, incidental, or consequential damages,
                        including loss of business, loss of profits, litigation, or other losses. These limitations are
                        fundamental to the agreement between the company and the user. Any advice or information
                        obtained through the site does not create any warranty, representation, or guarantee not
                        expressly stated in the agreement.
                    </p>

                    <p class="mt-2 font-semibold">Any reliance you place on such information is strictly at your own
                        risk.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Academic Content and Programs</h5>
                    <p class="mt-2">
                        The content related to academic courses, programs, curricula, fee structure, admission
                        procedure, and timelines available on the site is indicative and may change or be updated
                        frequently as per the UGC guidelines, university policies, and other regulatory requirements. To
                        avoid any kind of miscommunication, we encourage students, parents, or visitors to verify
                        information through reliable sources by contacting ARNI University administration or the
                        relevant department directly to have the most updated and complete information.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">No Legal Liability</h5>
                    <p class="mt-2">
                        As one of the fastest-growing educational institutions in North India, we strive to provide
                        accurate and updated information on the website. However, ARNI University does not claim and
                        will not be liable for any loss or damage including, without limitation, indirect or
                        consequential loss or damage, or any loss or damage whatsoever arising from data loss or profits
                        arising out of or in connection with the use of this website.
                    </p>
                    <p class="mt-2 font-semibold">The Rights or password assigned to obtain/download any content are
                        non-transferable.
                    </p>
                    <h5 class="text-lg font-semibold mt-4">External Links</h5>
                    <p class="mt-2">
                        Our website may contain external links that directed visitors to third-party sites, we do not
                        claim any control over their terms of use and policies. The links provided are for
                        convenience/reference/marketing purposes only. We do not take any responsibility for any kind of
                        damage or loss related to other sites. Thus, we encourage you to read their terms & conditions,
                        ensure proper authenticity and reliability on your own.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Technical Issues</h5>
                    <p class="mt-2">
                        Every effort is made to keep the website up and running smoothly. However, ARNI University takes
                        no responsibility for and will not be liable for the website being temporarily unavailable due
                        to technical issues beyond our control.
                    </p>

                    <p class="mt-2 font-semibold">To know more about ARNI Policies, please visit our Privacy Policy and
                        Terms and Conditions Pages
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Contact for Clarifications</h5>
                    <p class="mt-2">
                        If you require further clarification regarding any information provided on this website, we
                        encourage you to reach out directly to the concerned department or the university
                        administration.
                    </p>
                    <p class="mt-2">ARNI University, Kathgarh, Tehsil Indora,</p>
                    <p class="mt-2">District Kangra, Himachal Pradesh - 176401</p>
                    <p class="mt-2">Phone – 18008918962</p>
                    <p class="mt-2">
                        <span class="font-semibold">Website:</span>
                        <a href="http://www.arniuniversity.edu.in" class="text-blue-400 font-medium"> www.arniuniversity.edu.in</a>,<br/>
                        <span class="font-semibold">Email:</span>
                        <a href="mailto:info@arniuniversity.edu.in" class="text-blue-400 font-medium"> info@arniuniversity.edu.in</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
